<template>
  <div>
    <v-dialog ref="dialog"
      @keydown.esc="modal=false"
      v-model="modal"
      :return-value.sync="current_dates"
      persistent
      width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateRangeText"
            label="Fechas"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"></v-text-field>
        </template>
        <v-date-picker
          v-model="current_dates"
          range
          :allowed-dates="alloweDates"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(current_dates)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'date-filter',
  props: {
    dates: {
      type: Array,
      required: true
    },
    filter: {
      type: Number,
      required: true,
      default: null
    }
  },
  data () {
    return {
      modal: false,
      current_dates: [
        this.$moment().startOf('day').format('YYYY-MM-DD'),
        this.$moment().endOf('day').format('YYYY-MM-DD')
      ]
    }
  },
  computed: {
    dateRangeText () {
      return this.dates.join(' al ')
    },
    type () {
      if (this.filter === 0) return 'week'
      if (this.filter === 1) return 'month'
      if (this.filter === 3) return 'year'
      return 'week'
    }
  },
  watch: {
    current_dates: function (value) {
      switch (this.filter) {
        case 0:
          this.$refs.dialog.save(this.getFilteredDates(value, 'week'))
          break
        case 1:
          this.$refs.dialog.save(this.getFilteredDates(value, 'month'))
          break
        case 2:
          this.$refs.dialog.save(this.getFilteredDates(value, 'year'))
          break

        default:
          break
      }
      this.$emit('update:change', value)
    },
    dates: function (value) {
      if (value === undefined) this.dates = this.current_dates
      else this.current_dates = value
    }
  },
  mounted () {
    this.$emit('update:change', this.getFilteredDates([], this.type))
  },
  methods: {
    getFilteredDates (value = [], type = '') {
      return [this.$moment(value[0]).startOf(type).format('YYYY-MM-DD'), this.$moment(value[0]).endOf(type).format('YYYY-MM-DD')]
    },
    alloweDates (val) {
      return this.$moment(val).isSameOrAfter(this.$moment().subtract(4, this.type).startOf(this.type)) && this.$moment(val).isSameOrBefore(this.$moment().endOf(this.type))
    }
  }
}
</script>
